import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import withAdminLayout from '../../layout/withAdminLayout';

const Dashboard = lazy(() => import('../../container/marketing/Index'));
const CampaignGallery = lazy(() => import('../../container/marketing/CampaignGallery'));

function MarketingRoutes() {
    return (
        <Suspense fallback={<div className="spin"><Spin /></div>}>
            <Routes>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="campaign-gallery" element={<CampaignGallery />} />
                <Route path="*" element={<Navigate to="/asm/marketing/dashboard" replace />} />
            </Routes>
        </Suspense>
    );
}

export default withAdminLayout(MarketingRoutes);
